/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ItemTileBase_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly localizedPdpUrl: string | null;
    readonly classification: {
        readonly creationDate: string | null;
    } | null;
    readonly creators: ReadonlyArray<{
        readonly attribution: string | null;
        readonly creator: {
            readonly displayName: string | null;
        } | null;
    } | null> | null;
    readonly isArt: boolean | null;
    readonly seller?: {
        readonly serviceId: string | null;
        readonly sellerProfile: {
            readonly company: string | null;
        } | null;
    } | null | undefined;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly " $fragmentRefs": FragmentRefs<"Shipping_item" | "StorefrontOnly_item" | "SwatchSelectorMinimal_item" | "Price_item" | "QuickViewItem_item" | "ProductTileMeasurements_item" | "AuctionBids_item">;
    readonly " $refType": "ItemTileBase_item";
};
export type ItemTileBase_item$data = ItemTileBase_item;
export type ItemTileBase_item$key = {
    readonly " $data"?: ItemTileBase_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "buyerId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchShippingCostInfo"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileBase_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "kind": "LinkedField",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attribution",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "condition": "showSeller",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SellerProfile",
              "kind": "LinkedField",
              "name": "sellerProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "company",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "buyerId"
        },
        {
          "kind": "Variable",
          "name": "fetchShippingCostInfo",
          "variableName": "fetchShippingCostInfo"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Shipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontOnly_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SwatchSelectorMinimal_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Price_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductTileMeasurements_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "pageDisplayEnum"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AuctionBids_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '1d9b44407385c6ef711740c0a19d6eb5';
export default node;
